export default "__VITE_ASSET__pEe6V4e5__"